import { Redirect, Route } from "react-router-dom";
import useAuth from "./auth/useAuth";
import { Box } from "@mui/material";

export const PublicRoute = ({ component: Component, ...rest }) => {
  const auth = useAuth();
  
  if (!auth.isInitialized) {
    return <Route {...rest} render={() => <Box />} />;
  }
  
  return (
    <Route
      {...rest}
      render={(props) =>
        !auth.isAuthenticated
          ? <Component {...props} />
          : <Redirect to="/admin/overview" />
      }
    />
  );
};
